/* ============================================================
   6zero – Etapa 5: header compacto ao rolar e avisos de nova aba
   (22/10/2026). Não altera o theme.js.
   ============================================================ */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  /* ----------------------------------------------------------
     i33 — Header fixo compacto (desktop, a partir de 992px)
     Rolando para baixo: some a linha do menu e o logo diminui.
     Rolando para cima (ou com o foco do teclado no header): o menu volta.
     A altura que o header perde vira margem embaixo dele, então
     o conteúdo da página não pula.
     ---------------------------------------------------------- */
  function setupHeader() {
    var header = document.querySelector('header.site-header');
    if (!header) return;
    var desktop = window.matchMedia('(min-width: 992px)');
    var compacto = false;
    var ocupado = false;
    var ultimoY = window.scrollY;
    var acumulado = 0;

    function aplicar(ligar) {
      if (ligar === compacto) return;
      ocupado = true;
      if (ligar) {
        var antes = header.offsetHeight;
        header.classList.add('cabecalho-compacto');
        var depois = header.offsetHeight;
        header.style.marginBottom = Math.max(0, antes - depois) + 'px';
      } else {
        header.classList.remove('cabecalho-compacto');
        header.style.marginBottom = '';
      }
      compacto = ligar;
      acumulado = 0;
      setTimeout(function () {
        ocupado = false;
        ultimoY = window.scrollY;
      }, 200);
    }

    function aoRolar() {
      if (!desktop.matches) { aplicar(false); return; }
      if (ocupado) return;
      var y = window.scrollY;
      var delta = y - ultimoY;
      ultimoY = y;
      if (y < 200) { aplicar(false); return; }
      if ((delta > 0 && acumulado < 0) || (delta < 0 && acumulado > 0)) acumulado = 0;
      acumulado += delta;
      if (acumulado > 60 && y > 320) aplicar(true);
      else if (acumulado < -60) aplicar(false);
    }

    window.addEventListener('scroll', aoRolar, { passive: true });
    window.addEventListener('resize', aoRolar);
    header.addEventListener('focusin', function () { aplicar(false); });
  }

  /* ----------------------------------------------------------
     i23 — Links que abrem em nova aba avisam isso ao leitor de tela.
     ---------------------------------------------------------- */
  var AVISO = ' (abre em nova aba)';

  function avisarNovaAba(raiz) {
    var links = (raiz || document).querySelectorAll('a[target="_blank"]');
    Array.prototype.forEach.call(links, function (a) {
      if (a.getAttribute('data-aviso-nova-aba')) return;
      a.setAttribute('data-aviso-nova-aba', '1');
      var label = a.getAttribute('aria-label');
      if (label) {
        if (label.indexOf(AVISO.trim()) === -1) a.setAttribute('aria-label', label + AVISO);
        return;
      }
      var s = document.createElement('span');
      s.className = 'visually-hidden';
      s.textContent = AVISO;
      a.appendChild(s);
    });
  }

  /* ----------------------------------------------------------
     i24 — Ícones copiados do SVGRepo repetiam os mesmos IDs
     (SVGRepo_bgCarrier etc.). Os IDs não são usados por nada.
     O contador de favoritos aparece no header e no menu do celular
     com o mesmo id; o script de favoritos usa a classe, não o id.
     ---------------------------------------------------------- */
  function limparIdsSvg() {
    Array.prototype.forEach.call(document.querySelectorAll('svg [id^="SVGRepo_"]'), function (el) {
      el.removeAttribute('id');
    });
    Array.prototype.forEach.call(document.querySelectorAll('[id="wishlistCounter"]'), function (el, i) {
      if (i > 0) el.removeAttribute('id');
    });
  }

  ready(function () {
    setupHeader();
    avisarNovaAba();
    limparIdsSvg();
  });
  window.addEventListener('load', function () {
    avisarNovaAba();
    limparIdsSvg();
  });
})();
